// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rewards .top-section{background:linear-gradient(61deg,var(--lms-tenant),#fff 100%)}.rewards .top-section h5{color:#fff!important}.rewards .top-section button{color:var(--lms-tenant)!important}.rewards .create,.rewards .details,.rewards .home{background-color:#fff}.page-heading,.rewards .create .import{color:var(--lms-tenant)}", ""]);
// Exports
module.exports = exports;
